import { Typography } from '@neo4j-ndl/react';
import { isNotNullish } from '@nx/stdlib';
import cx from 'classnames';

type PropertyDisplayProps =
  | {
      label: React.ReactNode;
      text?: React.ReactNode;
    }
  | {
      label: undefined;
      text: React.ReactNode;
    };

function PropertyDisplay({ label, text }: PropertyDisplayProps) {
  return (
    <Typography variant="body-small" className="flex items-center gap-1">
      {isNotNullish(label) ? <span className="text-neutral-text-weak">{label}:</span> : null}
      {text ?? '-'}
    </Typography>
  );
}

function PropertyList(props: React.PropsWithChildren) {
  return (
    <div className="border-neutral-border-weak flex flex-row gap-2 rounded-[8px] border p-2">{props.children}</div>
  );
}

interface DataSourceCardProps {
  actions?: React.ReactNode;
  isDisabled?: boolean;
  name: React.ReactNode;
  onConnect?: () => void;
}

export function DataSourceCard(props: React.PropsWithChildren<DataSourceCardProps>) {
  return (
    <div
      className={cx(
        'text-palette-neutral-text-default border-palette-neutral-border-weak bg-palette-neutral-bg-weak n-body-medium relative flex flex-col gap-2 overflow-hidden rounded-xl border p-3',
        { 'cursor-not-allowed': props.isDisabled === true, 'opacity-75': props.isDisabled === true },
      )}
    >
      <div className="flex items-baseline">
        <Typography variant="h5">{props.name}</Typography>
        <div className="ml-auto">{props.actions}</div>
      </div>
      {props.children}
    </div>
  );
}

DataSourceCard.PropertyList = PropertyList;

DataSourceCard.PropertyDisplay = PropertyDisplay;
